import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Font } from "ckeditor5";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export default function ModalSoanHangPhieuXuatKho({
  item,
  icons,
  icon,
  data: DATA,
}) {
  const { dataSoanHang } = DATA;
  const { lang, proxy, auth } = useSelector((state) => state);
  const [data, setData] = useState({});
  const [dataTable, setDataTable] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isEmpty, setEmpty] = useState(false);
  const token = localStorage.getItem("_token");

  const { control, handleSubmit, register, reset, setValue, getValues } =
    useForm({
      defaultValues: {
        dataLogsPXk: data?.[0]?.dataLogsPXk || [],
        ghichu: "",
      },
    });
  //   const { fields, remove, append } = useFieldArray({
  //     control,
  //     name: "dataLogsPXk",
  //   });

  useEffect(() => {
    if (data?.maphieuxuatkho) {
      fetch(proxy() + `/api/PXK/emptySoanHang/${data?.maphieuxuatkho}`, {
        headers: {
          Authorization: token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { status } = res;
          setEmpty(status);
        });
    }
  }, [data]);

  //   useEffect(() => {
  //     const dataLogsPXk = data?.[0]?.dataLogsPXk;
  //     const sanpham = data?.[0]?.sanpham;

  //     if (dataLogsPXk && dataLogsPXk.length) {
  //       const mapped = dataLogsPXk.map((item, index) => {
  //         return {
  //           ...item,
  //           tensanpham: item?.tensanpham ?? sanpham?.[index]?.["10TSP"],
  //         };
  //       });
  //       reset({
  //         dataLogsPXk: mapped,
  //         ghichu: "",
  //       });
  //     }
  //   }, [data, reset]);
  const handleModalShow = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setData({});
    setDataTable([]);
  };

  const onSubmit = () => {
    const { dataPXK } = DATA || {};
    const mappedData = {
      data: {
        ...dataPXK,
        data: dataTable.map((item) => ({
          delivery_detail_id: item?.delivery_detail_id,
          masanpham: item?.masanpham,
          soluongtanxuatthucte: item?.soluongtanxuatthucte,
          donvitinh: item?.donvitinh,
          solot: item?.solot,
          khocon: item?.khocon,
          vitritrongkho: item?.vitritrongkho,
        })),
        action: "create",
        lenhxuathang: data?.lenhxuathang,
        nguoitaophieu: data?.nguoitaophieu?.taikhoansaas,
      },
      TenTaiKhoanThietBi: data?.nguoitaophieu?.tentaikhoan,
      TaiKhoanThietBi: data?.nguoitaophieu?.mataikhoan,
    };
    // if (isEmpty) {
    //   Swal.fire({
    //     icon: "info",
    //     // title: lang["error"],
    //     text: `Phiếu Xuất Kho đã soạn hàng`,
    //     showConfirmButton: true,
    //   });
    //   return;
    // }

    Swal.fire({
      title: "Đang đồng bộ dữ liệu...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    fetch(proxy() + `/api/SyncERP/PhieuXuatKho`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(mappedData),
    })
      .then((res) => res.json())
      .then((res) => {
        const { o_message, o_status, o_description } = res;
        Swal.close();
        if (o_status !== "200") {
          Swal.fire({
            icon: "error",
            title: lang["error"],
            text: `ERP phản hồi: ${o_message || o_description}`,
            showConfirmButton: true,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: lang["success"],
            text: o_message || o_description,
          });
        }
      });
  };

  const handleAdd = () => {
    setDataTable((prev) => [...prev, data]);
    // setData({});
    // setRefresh((prev) => prev + 1);
  };
  return (
    <>
      <FontAwesomeIcon
        icon={icons[icon]?.icon}
        title={item?.title ? item?.title : lang["redirect_button"]}
        onClick={handleModalShow}
      />
      <Modal
        show={showModal}
        onHide={handleModalClose}
        dialogClassName="modal-80w"
      >
        <Modal.Header>
          <Modal.Title className="w-100">
            <div
              className="text-center fw-bold"
              style={{
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
            >
              {item?.title ? item?.title : lang["redirect_button"]}
            </div>
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row form-row align-items-center">
                <div className="col-sm-11">
                  <div className="header row mb-3">
                    <div className="col-sm-3">LXH/LĐĐNB</div>
                    <div className="col-sm-2">Số LOT</div>
                    <div className="col-sm-1">Kho Con</div>
                    <div className="col-sm-2">Vị trí</div>
                    <div className="col-sm-2">Tồn</div>
                    <div className="col-sm-2">Số Lượng (Tấn)</div>
                  </div>
                  <div className="input row mb-4" key={refresh}>
                    <div className="col-sm-3">
                      <Controller
                        control={control}
                        name={`lenhxuathang`}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={dataSoanHang?.map((item) => ({
                              label: [
                                item.lenhxuathang,
                                item.masanpham,
                                item.delivery_detail_id,
                              ]
                                .filter(Boolean)
                                .join("_"),
                              //   `${item?.lenhxuathang}_${item?.masanpham|| ""}_${item.delivery_detail_id || ""}`,
                              value: item,
                            }))}
                            onChange={(opt) => {
                              const { khocon, masanpham } = opt?.value || {};
                              if (masanpham && khocon) {
                                fetch(
                                  proxy() +
                                    `/api/SyncERP/Lot?id=${masanpham}&sub=${khocon}`,
                                  {
                                    headers: {
                                      Authorization: token,
                                      "Content-Type": "application/json",
                                    },
                                  }
                                )
                                  .then((res) => res.json())
                                  .then((res) => {
                                    const { data } = res;

                                    const uniqueSolotWithQty = data.reduce(
                                      (acc, curr) => {
                                        const existingSolot = acc.find(
                                          (item) => item.solot === curr.solot
                                        );

                                        if (existingSolot) {
                                          existingSolot.soluongconton +=
                                            curr.soluongconton;
                                        } else {
                                          acc.push({
                                            solot: curr.solot,
                                            soluongconton: curr.soluongconton,
                                            donvitinh: curr.donvitinh,
                                          });
                                        }
                                        return acc;
                                      },
                                      []
                                    );
                                    const uniqueViTri = [
                                      ...new Set(
                                        data.map((item) => item?.mavitrikho)
                                      ),
                                    ].filter(Boolean);
                                    setData((prev) => ({
                                      ...prev,
                                      danhSachSoLot: uniqueSolotWithQty.map(
                                        (item) => ({
                                          label: item.solot,
                                          value: item,
                                        })
                                      ),

                                      danhSachViTriKho: uniqueViTri.map(
                                        (vitrikho) => ({
                                          label: vitrikho,
                                          value: vitrikho,
                                        })
                                      ),
                                    }));
                                  })
                                  .then(() => setLoading(false));
                              }
                              setDataTable([]);
                              setData((prev) => ({
                                ...prev,
                                ...opt?.value,
                                maphieuxuatkho: DATA?.["maPhieuXuatKhoERP"],
                              }));
                            }}
                            placeholder={lang["select value"]}
                            noOptionsMessage={() => (
                              <>{lang["not found data"]}</>
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Controller
                        control={control}
                        name={`solot`}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={data?.danhSachSoLot}
                            onChange={(opt) => {
                              const { soluongconton, solot, donvitinh } =
                                opt?.value || {};
                              setData((prev) => ({
                                ...prev,
                                solot,
                                soluongconton,
                                donvitinh,
                              }));
                            }}
                            placeholder={lang["select value"]}
                            noOptionsMessage={() =>
                              loading ? (
                                <>Đang tải dữ liệu...</>
                              ) : (
                                <>{lang["not found data"]}</>
                              )
                            }
                          />
                        )}
                      />
                    </div>
                    <div className="col-sm-1">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.khocon}
                        readOnly
                        {...register("khoCon")}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Controller
                        control={control}
                        name={`vitri`}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={data?.danhSachViTriKho}
                            onChange={(opt) => {
                              setData((prev) => ({
                                ...prev,
                                vitritrongkho: opt?.value,
                              }));
                            }}
                            placeholder={lang["select value"]}
                            noOptionsMessage={() => (
                              <>{lang["not found data"]}</>
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-sm-2">
                      <input
                        type="text"
                        className="form-control"
                        value={`${data?.soluongconton || 0} Tấn`}
                        readOnly
                        {...register("soluongconton")}
                      />
                    </div>
                    <div className="col-sm-2">
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => {
                          const { value } = e.target;

                          setData((prev) => ({
                            ...prev,
                            soluongtanxuatthucte: parseFloat(value),
                          }));
                        }}
                        step="any"
                        min={0}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-1 text-right">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => handleAdd()}
                  >
                    Thêm
                  </button>
                </div>
                <table
                  className="table-custom rounded w-100"
                  style={{
                    border: "1px solid rgba(0,0,0,.2)",
                  }}
                >
                  <thead>
                    <tr>
                      <td className="align-center">Lot</td>
                      <td className="align-center">Kho Con</td>
                      <td className="align-center">Vị Trí</td>
                      <td className="align-center">Số Lượng</td>
                      <td width={1}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {dataTable.map((item, index) => {
                      return (
                        <tr>
                          <td>{item.solot}</td>
                          <td>{item.khocon}</td>
                          <td>{item.vitritrongkho}</td>
                          <td>{item.soluongtanxuatthucte}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-danger m-0"
                              onClick={() => {
                                setDataTable((prev) =>
                                  prev.filter((_, idx) => idx !== index)
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              justifyContent: "center",
            }}
          >
            <Button variant="success" type="submit" disabled={isEmpty}>
              Xác nhận soạn hàng ERP
            </Button>
            <Button
              variant="secondary"
              className="ml-2"
              onClick={handleModalClose}
            >
              Đóng
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
